import { useQuery } from "@tanstack/react-query";

import { processResponse } from "Infrastructure/Api/ApiUtils";
import { getRegistrationRequestDetail } from "RegistrationRequests/Api/registrationRequestApi";
import { REGISTRATION_REQUESTS_QUERY_KEYS } from "./queryKeys";

export function useRegistrationRequestDetailQuery(
  registrationRequestID: string | undefined,
) {
  return useQuery({
    queryKey: REGISTRATION_REQUESTS_QUERY_KEYS.detail(
      registrationRequestID ?? "",
    ),
    queryFn: processResponse(() =>
      getRegistrationRequestDetail(registrationRequestID ?? ""),
    ),
    enabled: !!registrationRequestID,
  });
}
